import type { Color } from 'src/types/theme';

export const comparison: Color = {
  50: '#F7EBFD',
  100: '#E0C3EE',
  200: '#B46DD5',
  300: '#A149CB',
  400: '#8F25C1',
  500: '#771EA0',
  600: '#5F1880',
  700: '#471260',
  800: '#2F0C40',
  900: '#170620',
};
